// utils/getCurrentUser.js

// Single source of truth for resolving "who is the current user" across
// the app. Both PinToHome (which SAVES favorites) and any component that
// FETCHES favorites (like Cable.js) must use this exact same function,
// otherwise a favorite gets saved under one identity and looked up under
// another, causing pins to silently "disappear."
export function getCurrentUser() {
  const userStr = localStorage.getItem("user");
  if (userStr) {
    try {
      const parsedUser = JSON.parse(userStr);
      // user_id/userId is the globally-unique login handle (one email can
      // own several independent accounts). Prefer that; fall back to
      // username, then email, only if nothing else is available.
      return (
        parsedUser.userId ||
        parsedUser.user_id ||
        parsedUser.username ||
        parsedUser.email
      );
    } catch (e) {
      console.error("Failed to parse user data from localStorage:", e);
    }
  }
  return localStorage.getItem("userId") || localStorage.getItem("userName");
}